import React from "react";
import {
  Container,
  CssBaseline,
  Box,
  Typography,
  Paper,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: 20,
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    maxWidth: 500,
    textAlign: "center",
    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.2)",
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 700,
    color: "#333",
  },
  message: {
    marginBottom: theme.spacing(2),
    color: "#666",
    fontSize: 15,
    lineHeight: 1.5,
  },
  contactInfo: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: "#f5f5f5",
    borderRadius: 10,
    width: "100%",
  },
  contactText: {
    color: "#555",
    fontSize: 14,
  },
  logo: {
    maxWidth: 200,
    marginBottom: theme.spacing(2),
  },
}));

const BlockedAccess = () => {
  const classes = useStyles();
  const logo = require("../../assets/logomarca.png");

  return (
    <div className={classes.container}>
      <CssBaseline />
      <Container component="main" maxWidth="sm">
        <Paper className={classes.paper} elevation={6}>
          <img src={logo} className={classes.logo} alt="Logo" />

          <Typography component="h1" variant="h5" className={classes.title}>
            Acesso Temporariamente Suspenso
          </Typography>

          <Typography variant="body1" className={classes.message}>
            Identificamos <strong>faturas em aberto</strong> em sua conta. 
            Para restabelecer o acesso, solicitamos a regularização financeira.
          </Typography>

          <Box className={classes.contactInfo}>
            <Typography variant="body2" className={classes.contactText}>
              <strong>Para regularizar sua situação, entre em contato com o Departamento Financeiro:</strong>
            </Typography>
            <Typography variant="body2" className={classes.contactText} style={{ marginTop: 12 }}>
              📱 <strong>WhatsApp:</strong> (27) 3019-2484
            </Typography>
            <Typography variant="body2" className={classes.contactText} style={{ marginTop: 8 }}>
              ✉️ <strong>E-mail:</strong> atendimento@ssabrasil.com
            </Typography>
            <Typography variant="body2" className={classes.contactText} style={{ marginTop: 16, fontStyle: 'italic' }}>
              Agradecemos sua compreensão e aguardamos o seu retorno.
            </Typography>
          </Box>
        </Paper>
      </Container>
    </div>
  );
};

export default BlockedAccess;
